import React from 'react';
import { Heart, Facebook, Instagram } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <p className="body-medium footer-tagline">
              Where strength meets soul, built from the inside out.
            </p>
          </div>

          <div className="footer-purpose">
            <h4 className="heading-3">My Approach</h4>
            <p className="body-small footer-text">
              Strong body, clear mind, free spirit, inspired action.
            </p>
          </div>
        </div>

        <div className="footer-social">
          <h3 className="social-heading">Let's stay social!</h3>
          <div className="social-links">
            <a 
              href="https://www.facebook.com/share/16yFhgL8mV/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Follow us on Facebook"
            >
              <Facebook size={24} />
            </a>
            <a 
              href="https://www.instagram.com/the_ab_0riginal/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Follow us on Instagram"
            >
              <Instagram size={24} />
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="body-small">
            © {currentYear} HEATH & Wellbeing. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
